<template>
  <footer class="main-footer">
    <!-- <div class="pull-right hidden-xs">
      <b>Version</b> 1.1
    </div> -->
    <!-- Devin Vue Admin &copy; 2017 <a href="#"><strong>Matirasa</strong></a>. Made with love -->
    <!-- <footer class="main-footer"> -->
      <div class="container-fluid">
        <div class="pull-left">
          <p>© Copyright {{year}}
            <strong>
              <a href="http://www.novaassure.com" style="color: inherit">Nova Assure</a>.
            </strong> All rights reserved.
          </p>
          <p>1945 Camino Vida Roble, Carlsbad, CA 92008</p>
        </div>
        <div class="pull-right">
          <p>Toll free <a href="tel:#1-800-734-9885">#1-800-734-9885</a></p>
        </div>
      </div>
      <!-- /.container -->
    <!-- </footer> -->
  </footer>
</template>

<script>
export default {
  name: 'DashboardFooter',
  computed: {
    year () {
      return (new Date()).getFullYear()
    }
  }
}
</script>




// WEBPACK FOOTER //
// Footer.vue?3f73633e